module.exports = __webpack_public_path__ + "img/financialSettings.d279d285.svg";